import { ISummary, ISummaryResponse } from 'Modules/videoHistory/types/summary.types';

/**
 * Converts a summary response to a summary model.
 * @param response - The summary response to convert.
 * @returns The summary model.
 */
export const summaryResponseToModel = (response: ISummaryResponse): ISummary => {
  return {
    id: response.id,
    status: response.summary.status,
    generatedAt: response.summary.generatedAt,
    requestedByParticipantId: response.summary.requestedByParticipantId,
    text: response.summary.text,
  };
};